import { FC, useRef, useState, useEffect, useMemo } from 'react'
import { Box, Text, HStack } from '@chakra-ui/react'
import { dropTargetForElements } from '@atlaskit/pragmatic-drag-and-drop/element/adapter'
import get from 'lodash/get'
import last from 'lodash/last'
import Attempts from 'shared/components/sections/sectionTestLinkByMeaning/Attempts'

type Props = {
  value: string
  displayValue?: string
  onDragEndResult: (value: string, attempts: boolean[]) => void
}

const DroppableArea: FC<Props> = ({ value, displayValue, onDragEndResult }) => {
  const ref = useRef(null)
  const [isDraggedOver, setIsDraggedOver] = useState(false)
  const [attempts, setAttempts] = useState<boolean[]>([])

  console.log('value: ', value)

  const isComplete = useMemo(() => {
    return last(attempts) === true || attempts.length === 3
  }, [attempts])

  useEffect(() => {
    const el = ref.current

    return dropTargetForElements({
      element: el,
      onDragEnter: () => setIsDraggedOver(true),
      onDragLeave: () => setIsDraggedOver(false),
      getData: () => ({ value }),
      onDrop: (args) => {
        console.log('ON DROP:', args)
        // onDragEndResult()
        const droppedValue = get(args.source.data, 'value') as string
        const matches = value === droppedValue
        const newAttempts = [...attempts, matches]
        setAttempts(newAttempts)
        onDragEndResult(value, newAttempts)
        setIsDraggedOver(false)
      },
      canDrop: ({ source }) => {
        return true
      }
    })
  }, [value, attempts])

  const { bg, color, borderColor } = useMemo(() => {
    const isCorrect = last(attempts) === true
    if (isComplete && isCorrect) {
      return {
        bg: 'green.50',
        borderColor: 'green.800',
        color: 'green.800'
      }
    } else if (isComplete && !isCorrect) {
      return {
        bg: 'red.50',
        borderColor: 'red.700',
        color: 'red.700'
      }
    } else {
      return {
        bg: 'transparent',
        borderColor: 'black.200',
        color: 'white'
      }
    }
  }, [isComplete, attempts])

  return (
    <HStack
      w='auto'
      justify='flex-start'
      spacing={1}
      mx={1}
      // position={'relative'}
    >
      <HStack
        ref={ref}
        minW={isComplete ? 0 : 16}
        // w='fit-content'
        px={2}
        h={8}
        bg={isDraggedOver ? 'wood.200' : bg}
        rounded={'4px'}
        borderWidth={1}
        borderColor={borderColor}
        color={color}
        // position={'absolute'}
      >
        <Box>{isComplete && <Text whiteSpace={'nowrap'}>{displayValue || value}</Text>}</Box>
      </HStack>
      <Attempts attempts={attempts} />
    </HStack>
  )
}

export default DroppableArea
